export default __webpack_public_path__ + "media/images/dog-2-72620abc08fd301983f95798df2a80da.png";